module.exports = __webpack_public_path__ + "6012884eb49a527e24f1d3c143e65372.svg";